module.exports = new __parcel__URL__("Archerskill_33.156a66a2.png").toString();